import React,{useCallback, useEffect, useRef, useState} from 'react'
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Viewer } from '@react-pdf-viewer/core'; // install this library
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'; // install this library
import './PdfViewer.css'
import { Worker } from '@react-pdf-viewer/core'; // install this library
import LocalizationMap from './assets/en_US.json'
import { ReactElement } from 'react';
import { RenderDownloadProps, getFilePlugin } from '@react-pdf-viewer/get-file';

import GetAppIcon from '@mui/icons-material/GetApp';
import { useTranslation } from 'react-i18next';
import { CTooltip } from '../UI/CTooltip/CTooltip';
import { useTheme } from 'styled-components';
import { PVContainer, PVToHideMobile, PVToolbar, PVToolbarElements, PVToolbarElementsActions } from './PdfViewer.styled';
//import guideTeledeclaration from './assets/guideTeledeclaration.pdf'
//import guideProduction from './assets/guideProduction.pdf'
import './PdfViewer.css'
import { Modal } from 'react-bootstrap';
import CancelIcon from '@mui/icons-material/Cancel';

export const PdfViewer = ({ pdfFile, typeGuide, pdfFileName = "guide", closeModal, show, title="guide a lire" }) => {

    const guideTeledeclaration = "";
    const guideProduction = "";

    const [pdfView, setPdfView] = useState(null);
    const getFilePluginInstance = getFilePlugin();
    const { Download } = getFilePluginInstance;

    const downloadClickHandler = () => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
            let byteCharacters = atob(pdfFile);
            let byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            let blob = new Blob([byteArray], {type: 'application/pdf'});
            window.navigator.msSaveOrOpenBlob(blob, pdfFileName || "mandat.pdf");
        }
        else { // much easier if not IE
            //________Direct Download_____
            let blob = new Blob([pdfFile], { type: 'application/pdf' })
            const downloadUrl = URL.createObjectURL(blob)
            let a = document.createElement("a"); 
            a.href = "data:application/pdf;base64," + pdfFile;
            a.download = pdfFileName || "mandat.pdf";
            document.body.appendChild(a);
            a.click();

            //__________Visualize In The Browser _____
            // const blob = dataURItoBlob(data);
            // const url = URL.createObjectURL(blob);

            // // to open the PDF in a new window
            // window.open(url, '_blank');
        }
    }
    const renderToolbar = useCallback((Toolbar) => {
        
        return (
            <Toolbar  >
                {
                    (ToolbarSlot) => {
                        const {
                            CurrentPageInput, EnterFullScreen, GoToNextPage, GoToPreviousPage,
                            NumberOfPages, Print, ShowSearchPopover, Zoom, ZoomIn,
                            ZoomOut,Open
                        } = ToolbarSlot;
                        return (
                            <PVToolbar>
                                <PVToolbarElements>
                                    <PVToolbarElementsActions>
                                        <PVToHideMobile >
                                            <ShowSearchPopover />
                                        </PVToHideMobile>
                                        <PVToHideMobile>
                                            <ZoomOut />
                                        </PVToHideMobile>
                                        <PVToHideMobile>
                                            <Zoom />
                                        </PVToHideMobile>
                                        <PVToHideMobile>
                                            <ZoomIn />
                                        </PVToHideMobile>
                                        <PVToHideMobile>
                                            <GoToPreviousPage />
                                        </PVToHideMobile>
                                
                                            <CurrentPageInput /> / <NumberOfPages />
                                    
                                    
                                            <GoToNextPage />
                                      
                                    </PVToolbarElementsActions>
                                    <PVToolbarElementsActions>
                                        <PVToHideMobile>
                                            <EnterFullScreen />
                                        </PVToHideMobile>
                                        <div style={{ padding: '0px 2px' }}>
                                                <Download >
                                                    {
            
                                                        (props) => (
                                                            <div className="admViewer_download_icon" >
                                                                <CTooltip title="Télécharger"  >
                                                                    <GetAppIcon
                                                                        
                                                                        style={{
                                                                            //backgroundColor: '#357edd',
                                                                            border: 'none',
                                                                            borderRadius: '4px',
                                                                            //color: '#ffffff',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() => downloadClickHandler()}
                                                                    />
                                                                </CTooltip>
                                                            </div>
                                                            
                                                        )
                                                    }
                                                    
                                                </Download>
                                        </div>
                                        <div style={{ padding: '0px 2px', marginRight: "10px" }}>
                                            <Print />
                                        </div>
                                    </PVToolbarElementsActions>
                                </PVToolbarElements>
                            </PVToolbar>
                        )
                    }
                }
            </Toolbar>
        )
    }, [pdfFile])

    const docref = useRef();  

    function _base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    useEffect(() => {
        if (pdfFile){
            let pdfunit8 = _base64ToArrayBuffer(pdfFile)
            setPdfView(pdfunit8)
        } else
            setPdfView(null);
        
       
    }, [pdfFile])
  // Create new plugin instance
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        sidebarTabs: (defaultTabs) => [], // Afficher uniquement l'onglet des pages
        disableThumbnail: true, // Désactiver les vignettes
        //renderToolbar: renderToolbar, // Utiliser votre fonction renderToolbar personnalisée
    });
  

  const pageChangeHandler = (e) => {
      let currentPage = e?.currentPage + 1
      let docPages = e?.doc?._pdfInfo?.numPages
      if(currentPage === docPages){
        //   setAdmScrolledEnd(true)
      } 
  }

  const pdfScrollHandler = (e) => {
    let docPages = e?.doc?._pdfInfo?.numPages
    //let pdfContainer = document.querySelector(".rpv-default-layout-body")
    //setAdmPdfPages(docPages)
  }


    return (
        <Modal show={show} onHide={closeModal} size="lg">
            <Modal.Header closeButton>
                <Modal.Title className="Blue"> {typeGuide == "showGuideProduction" ? "Guide  du site de suivi" : "Guide du site de télédéclaration"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <PVContainer  ref={docref}  >
                    {
                        true &&
                            <>
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                                    <Viewer 
                                fileUrl={typeGuide == "showGuideProduction" ? guideProduction : guideTeledeclaration}
                                        // add toolbar and sidebar 
                                            //plugins={[defaultLayoutPluginInstance]}
                                        localization={LocalizationMap}
                                        onPageChange={(e) => pageChangeHandler(e)}
                                        onDocumentLoad={(e) => pdfScrollHandler(e)}
                                    />
                                </Worker>
                            </>
                    }

                    {/* if we dont have pdf or viewPdf state is null */}
                       
                </PVContainer>

      
            </Modal.Body>
            <Modal.Footer >
               
                <button style={{ color: "white", }} onClick={() => { closeModal() }} b-1paqisgac0="" type="button" class="btn btn-info" data-bs-dismiss="modal">Fermer</button>
            </Modal.Footer>
        </Modal>
  )
}

export default PdfViewer
